<template>
  <v-form
    ref="form"
    v-model="isValidationOk"
    lazy-validation>
    <v-container
      mt-4
      py-0
      fill-height
      fluid
      grid-list-xl>
      <v-layout wrap>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(dataSource.initialTime, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('Start date') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetDayHourMinuteSecondFormat(dataSource.initialTime, dataSource.finalTime)"
            :disabled="true"
            :label="`${$t('Duration')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetDayHourMinuteSecondFormat(0, dataSource.totalTime)"
            :disabled="true"
            :label="`${$t('Segments time')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="`${dataSource.validSegments + '/' + dataSource.invalidSegments}`"
            :disabled="true"
            :label="`${$t('No. of Segments')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(dataSource.finalTime, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('End date') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs6
          md2/>
        <v-flex
          xs6
          md4>
          <v-text-field
            :value="testResult"
            :disabled="true"
            :label="`${$t('Last result')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs4
          md2>
          <v-text-field
            :value="testCode"
            :disabled="true"
            :label="`${$t('Calculation code')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs2
          md6/>
        <v-flex
          xs12
          md12
          lg12>
          <hr>
          <span>
            {{ $t('Statistics') }}
          </span>
          <hr>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <v-data-table
            :headers="headers"
            :items="statistics"
            :no-data-text="`${Maglink.NoDataMessage(false)}`"
            :no-results-text="`${Maglink.NoDataMessage(true)}`"
            hide-actions>
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <v-layout
                align-center
                column
                ma-0>
                <v-flex
                  align-self-center
                  shrink>
                  <span
                    class="dover-light-blue-color"
                    v-text="header.text" />
                </v-flex>
                <v-flex
                  align-self-center
                  shrink>
                  <span
                    class="dover-light-blue-color h6"
                    v-text="header.subtext" />
                </v-flex>
              </v-layout>
            </template>
            <template
              slot="items"
              slot-scope="{ item }">
              <tr class="text-xs-left">
                <td>{{ item.mode }}</td>
                <td
                  v-if="item.height !== '-'"
                  class="text-xs-center">{{ Maglink.LevelToDisplay(item.height, systemSettings.levelUnit) }}</td>
                <td v-else/>
                <td
                  v-if="item.temperature !== '-'"
                  class="text-xs-center">{{ formatTemperature(item.temperature) }}</td>
                <td v-else/>
                <td
                  v-if="item.segment !== '-'"
                  class="text-xs-center">{{ formatTemperature(item.segment) }}</td>
                <td v-else/>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
        <v-flex
          xs12
          md12
          lg12>
          <hr>
        </v-flex>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="`${counters.passedTests}`"
            :disabled="true"
            :label="`${$t('Passed tests')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(counters.lastPassed, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('Last time') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs2
          md8/>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="`${counters.leakDetected}`"
            :disabled="true"
            :label="`${$t('Leak detected')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(counters.lastLeak, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('Last time') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs2
          md8/>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="`${counters.inconclusive}`"
            :disabled="true"
            :label="`${$t('Inconclusive results')}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs5
          md2>
          <v-text-field
            :value="Maglink.GetCustomDateTime(counters.lastInconclusive, systemSettings.dateFormat)"
            :disabled="true"
            :label="`${$t('Last time') + ' (' + $t(systemSettings.dateFormat) + ')'}`"
            class="dover-input" />
        </v-flex>
        <v-flex
          xs2
          md8/>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>

export default {
  props: {
    tank: {
      type: Object,
      required: true,
      default: () => { }
    },
    counters: {
      type: Object,
      required: true,
      default: () => { }
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => { }
    },
    options: {
      type: Object,
      required: true,
      default: () => { }
    },
    csldReasonCode: {
      type: Array,
      required: true,
      default: () => []
    },
    csldReasonDesc: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data: () => ({
    isValidationOk: false,
    dataSource: {},
    headers: [],
    statistics: [],
    levUdm: '',
    tempUdm: '',
    volUdm: '',
    testResult: '',
    testCode: ''
  }),
  watch: {
    tank: {
      immediate: true,
      deep: true,
      handler (newVal, oldVal) {
        this.dataSource = newVal.sldLeakage
        let measure = newVal.lastMeasurement
        let enabled = newVal.enabled
        let status = newVal.lastAlarm.tankStatus & 32

        let productLevel = measure.productLevel
        let temperature = measure.temperature

        if (enabled === 0 || status === 32) {
          productLevel = '-'
          temperature = '-'
        }

        if (newVal.lastAlarm.tankStatus & 4096) {
          if (newVal.lastSldReport.finalTime === 0) {
            this.testResult = this.$t('Stopped').toUpperCase()
            this.testCode = '-'
          } else {
            this.testResult = this.csldReasonDesc[newVal.lastSldReport.reason]
            this.testCode = this.csldReasonCode[newVal.lastSldReport.reason]
          }
        } else {
          if (newVal.lastSldReport.finalTime === 0) {
            this.testResult = this.$t('Test in progress').toUpperCase()
            this.testCode = '-'
          } else {
            this.testResult = this.csldReasonDesc[newVal.lastSldReport.reason]
            this.testCode = this.csldReasonCode[newVal.lastSldReport.reason]
          }
        }

        this.statistics = [
          { mode: this.$t('Max'), height: this.dataSource.maxHeight, temperature: this.dataSource.maxTemp, segment: this.dataSource.maxTempSeg },
          { mode: this.$t('Avg'), height: this.dataSource.avrHeight, temperature: this.dataSource.avrTemp, segment: this.dataSource.avrTempSeg },
          { mode: this.$t('Min'), height: this.dataSource.minHeight, temperature: this.dataSource.minTemp, segment: this.dataSource.minTempSeg },
          { mode: this.$t('Current'), height: productLevel, temperature: temperature, segment: '-' }
        ]
      }
    }
  },
  mounted () {
    this.levUdm = this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    this.tempUdm = this.options.temperatureUnits.find(c => c.code === this.systemSettings.temperatureUnit).desc
    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

    this.headers = [
      { sortable: false, text: '', subtext: '', align: 'center' },
      { sortable: false, text: this.$t('Product height'), subtext: this.levUdm, align: 'center' },
      { sortable: false, text: this.$t('Product temperature'), subtext: this.tempUdm, align: 'center' },
      { sortable: false, text: this.$t('Segment temperature'), subtext: this.tempUdm, align: 'center' }
    ]
  },
  methods: {
    formatTemperature (value) {
      if (value * 1.0 >= 999.0) {
        return '-'
      }

      return this.Maglink.TemperatureFormat(this.Maglink.TemperatureToDisplay(value, this.systemSettings.temperatureUnit))
    }
  }
}
</script>
